// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "user.proto" (package "users", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message users.User
 */
export interface User {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string email = 2
     */
    email: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: users.LoginMethod login_method = 4
     */
    loginMethod: LoginMethod;
    /**
     * @generated from protobuf field: bool is_admin = 5
     */
    isAdmin: boolean;
    /**
     * @generated from protobuf field: optional string last_seen_at = 6
     */
    lastSeenAt?: string;
    /**
     * @generated from protobuf field: optional bool shared_expenses_only = 7
     */
    sharedExpensesOnly?: boolean;
}
/**
 * @generated from protobuf message users.GetAllUsersRequest
 */
export interface GetAllUsersRequest {
}
/**
 * @generated from protobuf message users.GetAllUsersResponse
 */
export interface GetAllUsersResponse {
    /**
     * @generated from protobuf field: repeated users.User users = 1
     */
    users: User[];
}
/**
 * @generated from protobuf message users.GetUserDeletionImpactRequest
 */
export interface GetUserDeletionImpactRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message users.GetUserDeletionImpactResponse
 */
export interface GetUserDeletionImpactResponse {
    /**
     * @generated from protobuf field: uint32 accounts = 1
     */
    accounts: number;
    /**
     * @generated from protobuf field: uint32 transactions = 2
     */
    transactions: number;
    /**
     * @generated from protobuf field: uint32 categories = 3
     */
    categories: number;
    /**
     * @generated from protobuf field: uint32 currencies = 4
     */
    currencies: number;
    /**
     * @generated from protobuf field: uint32 moved_to_unconfirmed = 5
     */
    movedToUnconfirmed: number;
    /**
     * @generated from protobuf field: repeated string deleted_transaction_groups = 6
     */
    deletedTransactionGroups: string[];
    /**
     * @generated from protobuf field: repeated string blocking_transaction_groups = 7
     */
    blockingTransactionGroups: string[];
}
/**
 * @generated from protobuf message users.DeleteUserRequest
 */
export interface DeleteUserRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message users.DeleteUserResponse
 */
export interface DeleteUserResponse {
}
/**
 * @generated from protobuf enum users.LoginMethod
 */
export enum LoginMethod {
    /**
     * @generated from protobuf enum value: LOGIN_METHOD_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: LOGIN_METHOD_OIDC = 1;
     */
    OIDC = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class User$Type extends MessageType<User> {
    constructor() {
        super("users.User", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "login_method", kind: "enum", T: () => ["users.LoginMethod", LoginMethod, "LOGIN_METHOD_"] },
            { no: 5, name: "is_admin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "last_seen_at", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "shared_expenses_only", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<User>): User {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.email = "";
        message.name = "";
        message.loginMethod = 0;
        message.isAdmin = false;
        if (value !== undefined)
            reflectionMergePartial<User>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: User): User {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* users.LoginMethod login_method */ 4:
                    message.loginMethod = reader.int32();
                    break;
                case /* bool is_admin */ 5:
                    message.isAdmin = reader.bool();
                    break;
                case /* optional string last_seen_at */ 6:
                    message.lastSeenAt = reader.string();
                    break;
                case /* optional bool shared_expenses_only */ 7:
                    message.sharedExpensesOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: User, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* users.LoginMethod login_method = 4; */
        if (message.loginMethod !== 0)
            writer.tag(4, WireType.Varint).int32(message.loginMethod);
        /* bool is_admin = 5; */
        if (message.isAdmin !== false)
            writer.tag(5, WireType.Varint).bool(message.isAdmin);
        /* optional string last_seen_at = 6; */
        if (message.lastSeenAt !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.lastSeenAt);
        /* optional bool shared_expenses_only = 7; */
        if (message.sharedExpensesOnly !== undefined)
            writer.tag(7, WireType.Varint).bool(message.sharedExpensesOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.User
 */
export const User = new User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllUsersRequest$Type extends MessageType<GetAllUsersRequest> {
    constructor() {
        super("users.GetAllUsersRequest", []);
    }
    create(value?: PartialMessage<GetAllUsersRequest>): GetAllUsersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllUsersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllUsersRequest): GetAllUsersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllUsersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.GetAllUsersRequest
 */
export const GetAllUsersRequest = new GetAllUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllUsersResponse$Type extends MessageType<GetAllUsersResponse> {
    constructor() {
        super("users.GetAllUsersResponse", [
            { no: 1, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<GetAllUsersResponse>): GetAllUsersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllUsersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllUsersResponse): GetAllUsersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated users.User users */ 1:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllUsersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated users.User users = 1; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.GetAllUsersResponse
 */
export const GetAllUsersResponse = new GetAllUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserDeletionImpactRequest$Type extends MessageType<GetUserDeletionImpactRequest> {
    constructor() {
        super("users.GetUserDeletionImpactRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetUserDeletionImpactRequest>): GetUserDeletionImpactRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetUserDeletionImpactRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserDeletionImpactRequest): GetUserDeletionImpactRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserDeletionImpactRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.GetUserDeletionImpactRequest
 */
export const GetUserDeletionImpactRequest = new GetUserDeletionImpactRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserDeletionImpactResponse$Type extends MessageType<GetUserDeletionImpactResponse> {
    constructor() {
        super("users.GetUserDeletionImpactResponse", [
            { no: 1, name: "accounts", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "transactions", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "categories", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "currencies", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "moved_to_unconfirmed", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "deleted_transaction_groups", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "blocking_transaction_groups", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetUserDeletionImpactResponse>): GetUserDeletionImpactResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accounts = 0;
        message.transactions = 0;
        message.categories = 0;
        message.currencies = 0;
        message.movedToUnconfirmed = 0;
        message.deletedTransactionGroups = [];
        message.blockingTransactionGroups = [];
        if (value !== undefined)
            reflectionMergePartial<GetUserDeletionImpactResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserDeletionImpactResponse): GetUserDeletionImpactResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 accounts */ 1:
                    message.accounts = reader.uint32();
                    break;
                case /* uint32 transactions */ 2:
                    message.transactions = reader.uint32();
                    break;
                case /* uint32 categories */ 3:
                    message.categories = reader.uint32();
                    break;
                case /* uint32 currencies */ 4:
                    message.currencies = reader.uint32();
                    break;
                case /* uint32 moved_to_unconfirmed */ 5:
                    message.movedToUnconfirmed = reader.uint32();
                    break;
                case /* repeated string deleted_transaction_groups */ 6:
                    message.deletedTransactionGroups.push(reader.string());
                    break;
                case /* repeated string blocking_transaction_groups */ 7:
                    message.blockingTransactionGroups.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserDeletionImpactResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 accounts = 1; */
        if (message.accounts !== 0)
            writer.tag(1, WireType.Varint).uint32(message.accounts);
        /* uint32 transactions = 2; */
        if (message.transactions !== 0)
            writer.tag(2, WireType.Varint).uint32(message.transactions);
        /* uint32 categories = 3; */
        if (message.categories !== 0)
            writer.tag(3, WireType.Varint).uint32(message.categories);
        /* uint32 currencies = 4; */
        if (message.currencies !== 0)
            writer.tag(4, WireType.Varint).uint32(message.currencies);
        /* uint32 moved_to_unconfirmed = 5; */
        if (message.movedToUnconfirmed !== 0)
            writer.tag(5, WireType.Varint).uint32(message.movedToUnconfirmed);
        /* repeated string deleted_transaction_groups = 6; */
        for (let i = 0; i < message.deletedTransactionGroups.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.deletedTransactionGroups[i]);
        /* repeated string blocking_transaction_groups = 7; */
        for (let i = 0; i < message.blockingTransactionGroups.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.blockingTransactionGroups[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.GetUserDeletionImpactResponse
 */
export const GetUserDeletionImpactResponse = new GetUserDeletionImpactResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserRequest$Type extends MessageType<DeleteUserRequest> {
    constructor() {
        super("users.DeleteUserRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteUserRequest>): DeleteUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteUserRequest): DeleteUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.DeleteUserRequest
 */
export const DeleteUserRequest = new DeleteUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserResponse$Type extends MessageType<DeleteUserResponse> {
    constructor() {
        super("users.DeleteUserResponse", []);
    }
    create(value?: PartialMessage<DeleteUserResponse>): DeleteUserResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteUserResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteUserResponse): DeleteUserResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteUserResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.DeleteUserResponse
 */
export const DeleteUserResponse = new DeleteUserResponse$Type();
/**
 * @generated ServiceType for protobuf service users.UserService
 */
export const UserService = new ServiceType("users.UserService", [
    { name: "GetAllUsers", options: {}, I: GetAllUsersRequest, O: GetAllUsersResponse },
    { name: "GetUserDeletionImpact", options: {}, I: GetUserDeletionImpactRequest, O: GetUserDeletionImpactResponse },
    { name: "DeleteUser", options: {}, I: DeleteUserRequest, O: DeleteUserResponse }
]);
